/**
 * Meta Pixel helper — thin wrappers around `window.fbq`.
 *
 * Safe to call even when the Pixel hasn't loaded yet (e.g. blocked by an
 * ad-blocker, slow network, or running on the server during prerender).
 * Each function is a no-op in those cases.
 */
const fbq = (...args) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    try {
      window.fbq(...args);
    } catch (_e) {
      /* swallow: do not break the UX if Meta Pixel fails */
    }
  }
};

/** Standard PageView — call on every SPA route change. */
export const trackPageView = () => fbq('track', 'PageView');

/** Lead event — call when a contact/devis form submits successfully. */
export const trackLead = (params = {}) => fbq('track', 'Lead', params);

/** Contact event — call when the user clicks a phone-call link. */
export const trackContact = (params = {}) => fbq('track', 'Contact', params);

/** Custom WhatsApp event — call when the user clicks a WhatsApp link. */
export const trackWhatsApp = (params = {}) => fbq('trackCustom', 'WhatsApp', params);
